module.exports = __webpack_public_path__ + "static/media/TodayOverviewBoxGscale.5f4be3b3.png";